/*
 * Open the mega menus on hover, like the approved mockup.
 *
 * Studio/Dawn builds them as <details>/<summary>, which is click-only by design.
 * This adds hover on devices that actually have a pointer, and leaves click,
 * keyboard and touch behaviour untouched — <details> still works on its own if
 * this script never runs.
 *
 * Remove this file and its <script> tag in layout/theme.liquid to revert.
 */
(function () {
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!canHover.matches) return;

  // The panel sits below the header's padding, so travelling from the summary
  // into it crosses a few pixels of dead space. Close on a delay so that
  // gap doesn't make the menu flicker shut.
  var CLOSE_DELAY = 180;
  var closeTimer = null;

  function menus() {
    return Array.prototype.slice.call(document.querySelectorAll('.header__inline-menu header-menu'));
  }

  function setOpen(headerMenu, open) {
    var details = headerMenu.querySelector('details');
    var summary = headerMenu.querySelector('summary');
    if (!details) return;
    if (open === details.hasAttribute('open')) return;
    if (open) {
      details.setAttribute('open', '');
    } else {
      details.removeAttribute('open');
    }
    if (summary) summary.setAttribute('aria-expanded', String(open));
  }

  function openOnly(headerMenu) {
    clearTimeout(closeTimer);
    menus().forEach(function (m) {
      setOpen(m, m === headerMenu);
    });
  }

  function closeAllSoon() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      menus().forEach(function (m) {
        setOpen(m, false);
      });
    }, CLOSE_DELAY);
  }

  function bind() {
    menus().forEach(function (m) {
      if (m.dataset.hoverBound) return;
      m.dataset.hoverBound = 'true';
      m.addEventListener('mouseenter', function () {
        openOnly(m);
      });
      m.addEventListener('mouseleave', closeAllSoon);

      // Hover already opened it, so a click would immediately close it again.
      // Let the summary click through to its link target instead of toggling.
      var summary = m.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function (e) {
          if (m.querySelector('details').hasAttribute('open')) e.preventDefault();
        });
      }
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      clearTimeout(closeTimer);
      menus().forEach(function (m) {
        setOpen(m, false);
      });
    }
  });

  document.addEventListener('DOMContentLoaded', bind);
  // Section re-renders in the theme editor replace the header markup
  document.addEventListener('shopify:section:load', bind);
  bind();
})();
